<template>
  <v-dialog
    v-model="selectDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    width="70%"
    @keydown.esc="cancelAction"
  >
    
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="article, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title>
        <span class="headline">{{newTitle}}</span>
        <v-spacer></v-spacer>
          <v-btn
            text
            icon
            title="Cancelar"
            class="my-2"
            @click="cancelAction"
          >
            <v-icon right dark>mdi-close-circle</v-icon>
          </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
        >
          <p v-for="(error, index) in formErrors" class="mb-0" :key="error + index.toString()">
            {{error}}
          </p>
        </v-alert>

        <v-expansion-panels
          v-model="panelModel"
          multiple
          class="mt-5"
        >
          <v-expansion-panel v-for="account in accountsList" v-bind:key="account.id+'account'">
            <v-expansion-panel-header class="text-h6">Conta: <b class="mx-2" style="flex: inherit">{{account.name}}</b> <span class="text-subtitle-2 font-italic">(Perfil: <b>{{account.role.text}}</b>)</span></v-expansion-panel-header>
            <v-expansion-panel-content>
              
              <p v-if="account.grounds.length < 1">
                Não há fazendas cadastradas nesta conta ainda.
              </p>

              <v-list
                :flat="false"
                :dense="false"
                v-else
              >
                <v-list-item-group
                  :value="getListValue(account.id)"
                  :multiple="false"
                  :mandatory="false"
                  color="success"
                >
                  <template v-for="(item, i) in account.grounds">
                    <v-divider
                      :key="`divider-${i}`"
                    />
                    <v-list-item
                      :value="item.id"
                      :key="`list-item-${i}`"
                      @click="selectItem(item)"
                      :two-line="true"
                      class="px-1 px-sm-2 px-md-4"
                    >
                      <v-list-item-icon class="mr-1 mr-sm-2 mr-md-4 mr-lg-6">
                        <v-icon v-if="item.id == selectedObject.id">mdi-check-circle-outline</v-icon>
                        <v-icon v-else>mdi-radiobox-blank</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span class="title">{{item.name}} {{item.enabledName}}</span>
                          <br> 
                          <span class="text--disabled ml-2">{{item.typeName}}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="i == account.grounds.length - 1"
                      :key="`divider-last-${i}`"
                    />
                  </template>
                </v-list-item-group>
              </v-list>

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn class="my-2" @click="cancelAction">
          Cancelar
        </v-btn> -->

        <v-btn color="success" class="my-2" @click="confirmationAction">
          Confirmar
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <!-- color="primary" 
        class="mb-2"  -->
      <v-btn
        text
        v-on="on" 
        @click="openAction"
        :disabled="openSelectButtonDisabled">
          <v-icon left class="mr-2">mdi-map-outline</v-icon>
          {{openSelectButtonLabel}}        
      </v-btn>
    </template>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      selectDialog: false,
      accountsList: [],
      loading: true,
      pageLoading: false,
      formErrors: [],
      parentSelectedObject: {},
      selectedObject: {},
      panelModel: [],
    };
  },
  props: {
    idSelectedItem: {
      type: String
    },
    idParentSelectedItem: {
      type: String
    },
    dialog: {
      type: Boolean,
      default: true
    },
    openSelectButtonDisabled: {
      type: Boolean,
      default: false
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    newTitle: {
      type: String,
      default: "Seleção"
    },
    openSelectButtonLabel: {
      type: String,
      default: "Selecionar"
    },
  },
  components: {
    BaseUtil: BaseUtil,
  },
  computed: {
  },
  methods: {
    getListValue: function(accountId) {
      let returningList = null
      let accountObject = this.accountsList.find(obj => obj.id == accountId);
      let groundObject = accountObject.grounds.find(obj => obj.id == this.selectedObject.id);
      if (groundObject) {
        returningList = groundObject.id;
      }
      return returningList;
    },
    openSelectModal: function() {
      this.selectDialog = true;
      this.loadServerList();
      // link para abrir a modal direto
      // http://localhost:3000/app/grounds?selectGround
    },
    loadServerList: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_GROUNDS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.accountsList = response.data.accountContext.allUserAccounts;
          this.parentSelectedObject = this.accountsList.find(obj => obj.id == this.idParentSelectedItem);
          this.panelModel = [this.accountsList.indexOf(this.parentSelectedObject)];
          if (this.idSelectedItem){
            this.selectedObject = this.parentSelectedObject.grounds.find(obj => obj.id == this.idSelectedItem);
          }
          // this.selected = this.parentSelectedObject.grounds.indexOf(this.selectedObject);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    selectItem: function(item) { 
      // console.log("selectItem", item)
      this.selectedObject = item;
    },
    groundChangeConfirmation: function() {
      // console.log("select", item);
      this.pageLoading = true;
      let item = this.selectedObject;
      if (item) {
        this.$apollo
          .mutate({
            mutation: SELECT_GROUND_MUTATION,
            variables: {
              groundId: item.id,
            }
          })
          .then(response => {
            // console.log(response);
            this.selectAction();
            window.location.reload(); 
          })
          .catch(response => console.log(response))
          .finally(() => (this.pageLoading = true));
      }
    },
    confirmationAction: function(){
      this.pageLoading = true;
      this.groundChangeConfirmation();
      this.closeDialog();
      this.$emit("new-cancel-action")
    },
    cancelAction: function(){
      this.closeDialog();
      this.$emit("new-cancel-action")
    },
    selectAction: function(){
      this.$emit("select-action", this.selectedObject)
    },
    openAction: function() {
      this.loadServerList();
      // this.$emit("new-open-action")
    },
    closeDialog: function() {
      this.selectDialog = false;
    }
  },
};

const LOAD_ALL_GROUNDS_QUERY = gql `{
  accountContext {
    allUserAccounts {
      id
      name
      role {
        text
      }
      grounds {
        id
        name
        typeName
        enabledName
      }
    }
  }
}
`;

const SELECT_GROUND_MUTATION = gql `
  mutation($groundId: ID!) {
    selectGround(groundId: $groundId) {
      currentUser {
        id
        email
        isExpired
        expirationDays
        person {
          id
          name
        }
        groundId
        ground {
          name
        }
      }
      errors
    }
  }
`;

// mutation{
//   selectGround(groundId: 1){
//     currentUser{
//       groundId
//     }
//   }
// }

</script>

<style scoped></style>
